import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import AgroCareMarketplaceFeature from "./AgroCareMarketplaceFeature";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import AgroCareMarketplaceBenefits from "./AgroCareMarketplaceBenefits";
import "./AgroCareMarketPlace.css"
// Main component for AgroCareMarketPlace
export default function AgroCareMarketPlace() {
  // Overview Data
  const data1 = [
    "Buy and Sell Service: AgroCare Marketplace facilitates the trade of animal care, plant care, and farm equipment products, catering to diverse agricultural needs.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="agrocare-marketplace-bg"
        bannerTitle={["AgroCare Marketplace"]}
        bannerbodycopy="AgriInputsMarketplace | AgriServicesMarketplace"
      />

      {/* Overview section */}
      <SolutionEcosystem title="Overview" type="AGM" />

      {/* Overview Feature section */}
      <Container>
        <OverviewFeatures data1={data1} />
      </Container>

      {/* Features & Benefits section */}
      <AgroCareMarketplaceFeature />
      <AgroCareMarketplaceBenefits />
    </>
  );
}

